import React, { useState, useEffect } from "react";
import { useLocation, useSearchParams } from "react-router-dom";
import RecipeHistoryComponent from "./RecipeHistoryComponent";
import CalorieHistoryComponent from "./CalorieHistoryComponent";
import secureLocalStorage from "react-secure-storage";

const History = ({ initialTab = "recipes" }) => {
  const location = useLocation();
  const [searchParams, setSearchParams] = useSearchParams();

  // Determine initial tab from props, query param, or pathname
  const getInitialTab = () => {
    const tabParam = searchParams.get("tab");
    if (tabParam === "calories" || tabParam === "scans" || location.pathname === "/calhistory") {
      return "calories";
    }
    if (tabParam === "recipes") {
      return "recipes";
    }
    return initialTab;
  };

  const [activeTab, setActiveTab] = useState(getInitialTab);

  useEffect(() => {
    const tabParam = searchParams.get("tab");
    if (location.pathname === "/calhistory" || tabParam === "calories" || tabParam === "scans") {
      setActiveTab("calories");
    } else if (tabParam === "recipes") {
      setActiveTab("recipes");
    }
  }, [location.pathname, searchParams]);

  const handleTabChange = (tab) => {
    setActiveTab(tab);
    setSearchParams({ tab });
  };

  const loggedInUserEmail = JSON.parse(secureLocalStorage.getItem("loggedInUser"))?.email || "guest";
  const isGuest = !loggedInUserEmail || loggedInUserEmail === "guest";

  return (
    <div className="container py-3 mb-5 pb-5">
      {/* History Hero Header */}
      <div className="mb-3">
        <div className="d-flex align-items-center justify-content-between mb-1">
          <span
            className="badge rounded-pill px-2.5 py-1 bg-success bg-opacity-10 border border-success border-opacity-25 text-success fw-bold"
            style={{ fontSize: "11px" }}
          >
            📋 Full Activity Log
          </span>
          {isGuest && (
            <span className="badge rounded-pill bg-light text-secondary border" style={{ fontSize: "11px" }}>
              Guest Mode
            </span>
          )}
        </div>
        <h3 className="fw-bolder text-dark mb-1" style={{ fontSize: "1.5rem", letterSpacing: "-0.4px" }}>
          My History
        </h3>
        <p className="text-secondary small mb-0" style={{ fontSize: "12.5px" }}>
          Browse your full recipe creations and scanned meal calories in one place
        </p>
      </div>

      {/* Segmented 2-Way Tab Pill Switch matching Mockup */}
      <div
        className="history-segmented-switch p-1.5 rounded-pill mb-4 shadow-xs d-flex align-items-center"
      >
        <button
          type="button"
          className={`flex-fill border-0 rounded-pill py-2 px-3 fw-bold d-inline-flex align-items-center justify-content-center gap-2 history-tab-btn ${
            activeTab === "recipes" ? "active" : ""
          }`}
          onClick={() => handleTabChange("recipes")}
        >
          <i className="fi fi-rr-restaurant" style={{ fontSize: "0.95rem" }}></i>
          <span>Recipe History</span>
        </button>

        <button
          type="button"
          className={`flex-fill border-0 rounded-pill py-2 px-3 fw-bold d-inline-flex align-items-center justify-content-center gap-2 history-tab-btn ${
            activeTab === "calories" ? "active" : ""
          }`}
          onClick={() => handleTabChange("calories")}
        >
          <i className="fi fi-rr-flame" style={{ fontSize: "0.95rem" }}></i>
          <span>Calorie & Scan History</span>
        </button>
      </div>

      {/* Tab Content Display */}
      {activeTab === "recipes" ? (
        <div className="history-tab-pane">
          <RecipeHistoryComponent showLatest={false} />
        </div>
      ) : (
        <div className="history-tab-pane">
          <CalorieHistoryComponent showLatest={false} />
        </div>
      )}
    </div>
  );
};

export default History;
